import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import IndexBloc from "./Blocs/IndexBloc";
import Select from "react-select";
import apiResponse from "../../../../services/apiResponse";
import { Alert } from "reactstrap";
import IndexMonitoring5MinuteComponent from "./Components/IndexMonitoring5MinuteComponent";
import IndexMonitoring30MinuteComponent from "./Components/IndexMonitoring30MinuteComponent";
import IndexMonitoring1HourComponent from "./Components/IndexMonitoring1HourComponent";
import IndexMonitoring6HourComponent from "./Components/IndexMonitoring6HourComponent";
import IndexMonitoring1DayComponent from "./Components/IndexMonitoring1DayComponent";
import IndexMonitoring1WeekComponent from "./Components/IndexMonitoring1WeekComponent";
import IndexMonitoring1MonthComponent from "./Components/IndexMonitoring1MonthComponent";
import IndexMonitoring6MonthComponent from "./Components/IndexMonitoring6MonthComponent";
// import IndexMonitoringCpu1YearComponent from "./Components/CpuUsage/IndexMonitoring1YearComponent";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.state = {
      detail: null,
      listNameHost: [],
      listNamePeriod: [],
      activeTab: "1",
      selectedHost: null,
      selectedPeriod: null,
      isLoading: true,
    };

    this.activeRef = React.createRef();
    this.inactiveRef = React.createRef();
  }

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();
  reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI();

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  handleServerChange = (selectedOption) => {
    this.setState({ selectedHost: selectedOption });
  };

  handlePeriodChange = (selectedOption) => {
    this.setState({ selectedPeriod: selectedOption });
  };

  componentDidMount() {
    this.indexBloc.getallHostChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          const filteredResponse = response.filter(
            (item) => item.status === "0"
          );
          const hostOptions = filteredResponse.map((item) => ({
            value: item.hostid,
            label: item.name,
          }));
          const defaultHost = hostOptions.length > 0 ? hostOptions[0] : null;
          this.setState({
            listNameHost: hostOptions,
            selectedHost: defaultHost || null,
            isLoading: false,
          });
          break;
        case apiResponse.ERROR:
          this.setState({ isLoading: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.getAllPeriodChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          // console.log(response);
          const periodOptions = response.name.map((item) => ({
            value: item,
            label: item,
          }));
          const defaultPeriod = periodOptions.find(
            (option) => option.label === "5 Menit Terakhir"
          );
          this.setState({
            listNamePeriod: periodOptions,
            selectedPeriod: defaultPeriod || null,
            isLoading: false,
          });
          break;
        case apiResponse.ERROR:
          this.setState({ isLoading: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchAllHosts({});
    this.indexBloc.fetchAllPeriods({});
  }

  render() {
    const { selectedPeriod, isLoading } = this.state;
    const renderTableView = () => {
      return (
        <>
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-home"></i>
                </span>
                <span className="d-none d-sm-block">
                  <span className="uil-cloud-block"></span> Ping Server
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={this.state.activeTab}
            className="p-3 text-muted"
          >
            {selectedPeriod && selectedPeriod.value === "5 Menit Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring5MinuteComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "30 Menit Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring30MinuteComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "1 Jam Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring1HourComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "6 Jam Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring6HourComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "1 Hari Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring1DayComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "1 Minggu Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring1WeekComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "1 Bulan Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring1MonthComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {selectedPeriod && selectedPeriod.value === "6 Bulan Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoring6MonthComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )}

            {/* {selectedPeriod && selectedPeriod.value === "1 Tahun Terakhir" && (
              <TabPane tabId="1">
                <IndexMonitoringCpu1YearComponent
                  ref={this.activeRef}
                  handleInactiveSuccess={this.reloadInactiveRef}
                  selectedHost={this.state.selectedHost}
                  selectedPeriod={this.state.selectedPeriod}
                />
              </TabPane>
            )} */}
          </TabContent>
        </>
      );
    };

    const renderView = () => {
      if (isLoading) {
        return (
          <div className="text-center">
            <div>
              <Spinner
                style={{ width: "3rem", height: "3rem", borderWidth: "0.4rem" }}
                color="dark"
              />
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Mengambil Data ...</span>
            </div>
          </div>
        );
      } else {
        return renderTableView();
      }
    };
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Alert color="info">
                    <CardTitle>Ping Server</CardTitle>
                    <CardSubtitle>
                      Bertujuan untuk mendeteksi gangguan atau downtime pada
                      server secara dini, sehingga tindakan pencegahan dapat
                      segera diambil sebelum mempengaruhi kinerja sistem secara
                      keseluruhan.
                    </CardSubtitle>
                  </Alert>
                  <hr />
                  <Row>
                    <Col md="3">
                      <label>Pilih Host : </label>
                      <br />
                      <Select
                        options={this.state.listNameHost}
                        placeholder="Pilih Host"
                        onChange={this.handleServerChange}
                        value={this.state.selectedHost}
                      />
                    </Col>

                    <Col md="3">
                      <label>Pilih Periode Waktu : </label>
                      <br />
                      <Select
                        options={this.state.listNamePeriod}
                        placeholder="Pilih Periode Waktu"
                        onChange={this.handlePeriodChange}
                        value={this.state.selectedPeriod}
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Card>
                      <CardBody>{renderView()}</CardBody>
                    </Card>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
